import { ThemeInput } from '@stardust-ui/react';

const theme: ThemeInput = {
    siteVariables: {
        brandIcon: '/images/icons/teams-96x96.png',
    },
};

export default theme;
